import { addDays, eachDayOfInterval, format, parseISO } from "date-fns";
import React, { useCallback } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DatePicker } from "../../../Common/Components/DatePicker";
import useCartTotal from "../../../Common/Hooks/useCartTotal";
import { fetchDeliveryType } from "../../../Services/CartService";
import { fetchWeekDaysOff } from "../../../Services/OrderService";
import { AddressPicker } from "../../Components/AddressPicker";
import {
  fetchTimeSlot,
  addOrder as storeOrderCreate,
} from "../../Services/OrderService";
import { isDateBetween } from "../../../Services/MainService";
import { getItem } from "../../../Services/Storage";
import OrderNotesPicker from "../../../Common/Components/OrderNotesPicker";

export const BookAnAppointment = () => {
  const customerId = useSelector((x) => x.CustomerId);
  const deliveryTypes = useSelector((x) => x.OrderTypes);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const coupon = useSelector((x) => x.Coupon);
  const pickupDate = useSelector((x) => x.PickupDate);
  const customer = useSelector((x) => x.Customer);
  const deliveryDate = useSelector((x) => x.DeliveryDate);
  const zone = useSelector((x) => x.Zone);
  const addresses = useSelector((x) => x.Addresses);
  const navigate = useNavigate();
  const [submitting, setSubmitting] = React.useState(false);
  const dispatch = useDispatch();
  const apiNotes = useSelector((x) => x.Customer?.customer_note) || [];
  

  const [loading, setLoading] = React.useState(false);
  const [pickupLoading, setPickupLoading] = React.useState(false);
  const [deliveryLoading, setDeliveryLoading] = React.useState(false);
  const [deliveryType, setDeliveryType] = React.useState(null);
  const [showPickup, setShowPickup] = React.useState(false);
  const [showDelivery, setShowDelivery] = React.useState(false);
  const [pickupRange, setPickupRange] = React.useState([]);
  const [sPickup, setSPickup] = React.useState(null);
  const [sPSlot, setSPSlot] = React.useState(null);
  const [deliveryRange, setDeliveryRange] = React.useState([]);
  const [sDelivery, setSDelivery] = React.useState(null);
  const [sDSlot, setSDSlot] = React.useState(null);
  const [addressModal, setAddressModal] = React.useState(null);
  const [address, setAddress] = React.useState({
    pickup: null,
    delivery: null,
  });
  const [loaded, setLoaded] = React.useState(false);
  const [note, setNote] = React.useState("");
  const [weekDaysOff, setWeekDaysOff] = React.useState(null);
  const [type, setType] = React.useState("regular");
  const [bookingType, setBookingType] = React.useState(null);

  const consumerRefCode = customer?.referral_reward?.consumer_referral_code;
  const referred_by = getItem("referred_by");

  const FilterRange = useCallback(
    (range) => {
      return range.filter((date) => {
        const day = format(date, "EEEE").toLowerCase();
        const dateStringFormatted = format(date, "yyyy-MM-dd");

        return (
          !weekDaysOff?.weekdaysOff.includes(day) &&
          !weekDaysOff?.offDays.includes(dateStringFormatted)
        );
      });
    },
    [weekDaysOff]
  );
  const HandleDeliveryChange = useCallback(
    (e) => {
      setSDelivery(e.date);
      setSDSlot(e.slot);
      dispatch({ type: "setDeliveryDate", payload: e });
      setShowDelivery(false);
    },
    [dispatch]
  );

  React.useEffect(() => {
    setDeliveryType(deliveryTypes.find((x) => x.id === orderTypeId));
  }, [orderTypeId, deliveryTypes]);
  React.useEffect(() => {
    if (bookingType)
      fetchWeekDaysOff(bookingType?.id).then(
        (res) => setWeekDaysOff(res),
        () => toast.error("Something went wrong!")
      );
  }, [bookingType]);

  React.useEffect(() => {
    setBookingType(
      deliveryTypes.find((x) => x.title?.trim()?.toLowerCase() === type)
    );
  }, [type, deliveryTypes]);

  React.useEffect(() => {
    setPickupLoading(true);
    if (weekDaysOff) {
      if (bookingType) {
        // console.log(bookingType);
        var sd = addDays(new Date(), bookingType?.pickup_duration);
        const ed = addDays(sd, (bookingType?.noOf_calender_dates || 15) - 1);
        const dif = FilterRange(eachDayOfInterval({ start: sd, end: ed }));
        if (pickupDate?.date && pickupDate?.slot) {
          fetchTimeSlot(
            format(pickupDate?.date, "yyyy-MM-dd"),
            1,
            bookingType?.id
          ).then(
            (res) => {
              const sl = res.findIndex((x) => x.id === pickupDate.slot.id);
              if (~sl) {
                setSPickup(pickupDate?.date);
                setSPSlot(pickupDate?.slot);
              } else {
                dispatch({ type: "setPickupDate", payload: null });
                toast.warn(
                  "Pickup Time slot you selected last time is not available now please select another slot!"
                );
              }
              setPickupLoading(false);
            },
            (er) => {
              // console.warn(er, "error on slot");
              toast.error("Something went wrong while fetching Time Slots.");
            }
          );
        } else setPickupLoading(false);
        // if (pickupDate?.date) {
        //   setSPickup(pickupDate?.date);
        // }
        // if (pickupDate?.slot) {
        //   setSPSlot(pickupDate?.slot);
        // }
        setPickupRange(dif);
      }
    }
  }, [pickupDate, weekDaysOff, bookingType, FilterRange, dispatch]);
  React.useEffect(() => {
    if (weekDaysOff) {
      if (pickupDate && bookingType) {
        let skip = bookingType?.duration;
        const sd = addDays(pickupDate.date, skip);
        const ed = addDays(sd, (bookingType?.noOf_calender_dates || 15) - 1);
        const dif = FilterRange(eachDayOfInterval({ start: sd, end: ed }));
        setDeliveryRange(dif);
        if (deliveryDate?.date) {
          const ld =
            typeof deliveryDate.date == "string"
              ? parseISO(deliveryDate.date)
              : deliveryDate.date;
          if (!isDateBetween(ld, sd, ed)) {
            dispatch({ type: "setDeliveryDate", payload: null });
            // toast.warn(
            //   "Delivery Time slot you selected last time is not available now please select another slot!"
            // );
          } else if (deliveryDate.slot) {
            setDeliveryLoading(true);
            fetchTimeSlot(
              format(ld, "yyyy-MM-dd"),
              2,
              bookingType?.id,
              pickupDate.slot?.id,
              format(pickupDate.date, "yyyy-MM-dd")
            ).then(
              (res) => {
                const sl = res.findIndex((x) => x.id === deliveryDate?.slot.id);
                if (~sl) {
                  setSDelivery(ld);
                  setSDSlot(deliveryDate?.slot);
                } else {
                  dispatch({ type: "setDeliveryDate", payload: null });
                  toast.warn(
                    "Delivery Time slot you selected last time is not available now please select another slot!"
                  );
                }
                setDeliveryLoading(false);
              },
              (er) => {
                // console.warn(er, "error on slot");
                toast.error("Something went wrong while fetching Time Slots.");
              }
            );
          }
        } else {
          if (!deliveryDate || !deliveryDate?.slot) {
            const pr = async () => {
              setDeliveryLoading(true);
              for (let i = 0; i < dif.length; i++) {
                const d = dif[i];
                try {
                  const res = await fetchTimeSlot(
                    format(deliveryDate?.date || d, "yyyy-MM-dd"),
                    2,
                    bookingType?.id,
                    pickupDate.slot?.id,
                    format(pickupDate.date, "yyyy-MM-dd")
                  );
                  if (res.length > 0) {
                    HandleDeliveryChange({
                      date: deliveryDate?.date || d,
                      slot: res[0],
                    });
                    break;
                  }
                } catch (er) {
                  console.warn(er, "error on slot");
                  toast.error(
                    "Something went wrong while fetching Time Slots."
                  );
                }
              }
              setDeliveryLoading(false);
            };
            pr();
          }
        }
      }
    }
  }, [
    pickupDate,
    bookingType,
    deliveryDate,
    weekDaysOff,
    FilterRange,
    dispatch,
    HandleDeliveryChange,
  ]);
  React.useEffect(() => {
    if (address.delivery || address.pickup) {
      dispatch({ type: "setAddresses", payload: address });
    }
  }, [address]);
  React.useEffect(() => {
    if (!loaded) {
      if (addresses) {
        setAddress(addresses);
      }
      setLoaded(true);
    }
  }, [addresses, loaded]);

  const HandlePickupChange = (e) => {
    setSPickup(e.date);
    setSPSlot(e.slot);
    dispatch({ type: "setPickupDate", payload: e });
    setShowPickup(false);
  };

  const HandleAddressChange = (e) => {
    if (addressModal === "pickup") {
      if (!zone) {
        dispatch({ type: "setZone", payload: e.laundry_zone_id });
      }
      setAddress((v) => ({ ...v, pickup: e }));
    } else {
      setAddress((v) => ({ ...v, delivery: e }));
    }
    setAddressModal(null);
  };
  const handleBookingTypeChange = (t) => {
    if (type !== t) {
      setType(t);
      setSPickup(null);
      setSPSlot(null);
      dispatch({ type: "setPickupDate", payload: null });
      setSDelivery(null);
      setSDSlot(null);
      dispatch({ type: "setDeliveryDate", payload: null });
    }
  };
  const placeOrder = () => {
    if (!loading) {
      const normalizedBookingType = Number(bookingType?.id);
      if (![1, 2].includes(normalizedBookingType)) {
        toast.error("Please select Regular or Express before placing the order.");
        return;
      }

      setSubmitting(true);
      const payload = [
        {
          order_process: "hub",
          is_hub_store: false,
          type: "appointment",
          user_id: customerId,
          payment_status: "unpaid",
          delivery_date: format(deliveryDate?.date, "yyyy-MM-dd HH:mm:ss.SSS"),
          pickup_date: format(pickupDate?.date, "yyyy-MM-dd HH:mm:ss.SSS"),
          payment_method: "cash_on_delivery",
          platform: 4,
          referred_by: referred_by,
          consumer_referral_code: consumerRefCode,
          pickup_coordinates: {
            latitude: address?.pickup?.latitude,
            longitude: address?.pickup?.longitude,
          },
          destination_coordinates: {
            latitude: address?.delivery?.latitude,
            longitude: address?.delivery?.longitude,
          },
          pickup_address: {
            floor: null,
            road: address?.pickup?.streetNo,
            house: address?.pickup?.houseNo,
            address: address?.pickup?.address,
            contact_person_name: address?.pickup?.contact_person_name,
            contact_person_number: address?.pickup?.contact_person_number,
            addressLine1: address?.pickup?.address1 || "",
            addressLine2: address?.pickup?.address2 || "",
            area: address?.pickup?.area?.[0]?.name || "",
            area_phase: address?.pickup?.phase?.[0]?.name || "",
          },
          destination_address: {
            floor: null,
            road: address?.delivery?.streetNo,
            house: address?.delivery?.houseNo,
            address: address?.delivery?.address,
            contact_person_name: address?.delivery?.contact_person_name,
            contact_person_number: address?.delivery?.contact_person_number,
            addressLine1: address?.pickup?.address1 || "",
            addressLine2: address?.pickup?.address2 || "",
            area: address?.pickup?.area?.[0]?.name || "",
            area_phase: address?.pickup?.phase?.[0]?.name || "",
          },
          bar_code: "",
          order_pickup_time_slot_id: pickupDate?.slot?.id,
          order_type_id: deliveryType?.id,
          booking_type: normalizedBookingType,
          order_delivery_time_slot_id: deliveryDate?.slot?.id,
          laundry_delivery_type_id: deliveryType?.id,
          service_id: null,
          category_id: null,
          delivery_charge: 0,
          pickup_schedule: format(pickupDate?.date, "yyyy-MM-dd HH:mm:ss.SSS"),
          delivery_schedule: format(
            deliveryDate?.date,
            "yyyy-MM-dd HH:mm:ss.SSS"
          ),
          pending: "",
          distance: 10.5,
          note,
          order_pickup_time_slot_date: format(
            pickupDate?.date,
            "yyyy-MM-dd HH:mm:ss.SSS"
          ),
          order_delivery_time_slot_date: format(
            deliveryDate?.date,
            "yyyy-MM-dd HH:mm:ss.SSS"
          ),
          laundryZoneId: zone,
          coupon_code: coupon?.code,
          order_pickup_time_slot: `${pickupDate?.slot?.start_time} - ${pickupDate?.slot?.end_time}`,
          order_delivery_time_slot: `${deliveryDate?.slot?.start_time} - ${deliveryDate?.slot?.end_time}`,
          cart: [],
          tax_amount: 0,
          order_amount: 0,
        },
      ];
      const afterOrder = (order) => {
        setSubmitting(false);
        console.log(order);
        navigate(`/store/orders`, {
          replace: true,
        });
        dispatch({ type: "setCart", payload: [] });
        dispatch({ type: "setOrderType", payload: null });
        dispatch({ type: "setBookingType", payload: null });
        dispatch({ type: "setOrderTypeId", payload: null });
        dispatch({ type: "setService", payload: null });
        dispatch({ type: "setCategory", payload: null });
        dispatch({ type: "setDeliveryDate", payload: null });
        dispatch({ type: "setPickupDate", payload: null });
        dispatch({ type: "setCoupon", payload: null });
        dispatch({ type: "setAddresses", payload: null });
        dispatch({ type: "setNote", payload: null });
        dispatch({ type: "setZone", payload: null });
      };
      storeOrderCreate(payload).then(
        (res) => {
          afterOrder(res);
        },
        (er) => {
          setSubmitting(false);
          if (er && er.errors && er.errors.length !== 0) {
            console.log(er);
            er.errors.forEach((x) => {
              toast.error(x.message);
            });
          }
        }
      );
    }
  };

  return (
    <>
      <div className="container" style={{ minHeight: "80vh" }}>
        <div className="row justify-content-center py-4">
          <div className="col-xl-6 col-lg-7 col-md-10 col-12">
            <h3 className="mb-1 fw-bold" style={{ letterSpacing: "-1px" }}>
              Come & Collect
            </h3>
            <hr />
            {loading ? (
              <div className="col-12 text-center">
                <Spinner variant="primary" />
              </div>
            ) : (
              <>
                {/* Booking Type */}
                <div className="card mb-3">
                  {!pickupLoading && !deliveryLoading ? (
                    <div className="card-body">
                      <span className="fw-semibold mb-3 d-block">
                        Booking Type
                      </span>

                      <div className="app-dates-container border border-gray rounded mt-4 py-2 py-md-0">
                        <div className="col-12 col-md-5 px-4">
                          <div className="py-3 border-r border-gray">
                            <div className="form-check mb-0 d-flex align-items-center flex-wrap">
                              <input
                                className="form-check-input me-3"
                                type="radio"
                                name="booking-type"
                                id="booking-type-regular"
                                value="regular"
                                checked={type === "regular"}
                                onChange={() =>
                                  handleBookingTypeChange("regular")
                                }
                              />
                              <label
                                className="form-check-label cursor-pointer"
                                htmlFor="booking-type-regular"
                              >
                                Regular
                                <small className="m-0 text-muted d-block">
                                  Delivery in 2 Days
                                </small>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                          &nbsp;
                        </div>
                        <hr className="w-100 my-2 d-block d-md-none" />
                        <div className="col-12 col-md-5 px-4">
                          <div className="py-3">
                            <div className="form-check mb-0 d-flex align-items-center flex-wrap">
                              <input
                                className="form-check-input me-3"
                                type="radio"
                                name="booking-type"
                                id="booking-type-express"
                                value="express"
                                checked={type === "express"}
                                onChange={(e) =>
                                  handleBookingTypeChange("express")
                                }
                              />
                              <label
                                className="form-check-label cursor-pointer"
                                htmlFor="booking-type-express"
                              >
                                Express
                                <small className="m-0 text-muted d-block">
                                  Delivery in 24 Hours
                                </small>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="w-100 text-center py-3">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* Address */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">Address</span>
                    <div
                      className="row cursor-pointer"
                      onClick={() => setAddressModal("pickup")}
                    >
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-circle-dot"
                          style={{ color: "#32b6e9" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Pickup Address</h6>
                        <p className="m-0">
                          {address.pickup
                            ? `${address.pickup?.address1}, ${address.pickup?.address2}, ${address.pickup?.area?.[0]?.name}, ${address.pickup?.phase?.[0]?.name}`
                            : "Select address"}
                        </p>
                        <hr style={{ borderStyle: "doted" }} />
                      </div>
                    </div>

                    <div
                      className="row cursor-pointer"
                      onClick={() => {
                        if (!address.pickup) {
                          toast.error("Please select pickup address first.");
                          return;
                        }
                        setAddressModal("delivery");
                      }}
                    >
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-location-dot text-primary"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Delivery Address</h6>
                        <p className="m-0">
                          {address.delivery
                            ? `${address.delivery?.address1}, ${address.delivery?.address2}, ${address.delivery?.area?.[0]?.name}, ${address.delivery?.phase?.[0]?.name}`
                            : "Select address"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Date pickers */}
                <div className="card mb-3">
                  {!pickupLoading && !deliveryLoading ? (
                    <div className="card-body">
                      <span className="fw-semibold mb-3 d-block">
                        Schedule Dates
                      </span>

                      <div className="app-dates-container border border-gray rounded mt-4 py-2 py-md-0">
                        <div className="col-12 col-md-5 px-4">
                          <small
                            style={{ position: "absolute", top: "-12px" }}
                            className="bg-white px-2"
                          >
                            Pickup
                          </small>
                          <div
                            className="d-flex align-items-center py-3 border-r border-gray cursor-pointer"
                            onClick={() => {
                              if (!address.pickup || !address.delivery) {
                                toast.error(
                                  "Please select pickup & delivery addresses to continue."
                                );
                                return;
                              }
                              setShowPickup(true);
                            }}
                          >
                            <i
                              className="fa-regular fa-calendar-plus me-3"
                              style={{ fontSize: "22px", color: "#666" }}
                            ></i>
                            {sPickup ? format(sPickup, "eee, do MMM") : "Date"}
                            {sPSlot && sPickup ? <br /> : "/"}
                            {sPSlot
                              ? `${sPSlot?.start_time} - ${sPSlot?.end_time}`
                              : "Time"}
                          </div>
                        </div>
                        <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                          &nbsp;
                        </div>
                        <hr className="w-100 my-2 d-block d-md-none" />
                        <div className="col-12 col-md-5 px-4">
                          <small
                            style={{ position: "absolute" }}
                            className={`bg-white px-2 app-dates-delivery-label ${
                              !sPickup && !sPSlot ? "alt" : ""
                            }`}
                          >
                            Delivery
                          </small>
                          <div
                            className="d-flex align-items-center py-3 cursor-pointer"
                            onClick={() => {
                              if (!address.pickup || !address.delivery) {
                                toast.error(
                                  "Please select pickup & delivery addresses to continue."
                                );
                                return;
                              }
                              if (sPickup && sPSlot) setShowDelivery(true);
                              else
                                toast.error(
                                  "Please select pickup date & slot first..."
                                );
                            }}
                          >
                            <i
                              className="fa-regular fa-calendar-plus me-3"
                              style={{ fontSize: "22px", color: "#666" }}
                            ></i>
                            {sDelivery
                              ? format(sDelivery, "eee, do MMM")
                              : "Date"}
                            {sDSlot && sDelivery ? <br /> : "/"}
                            {sDSlot
                              ? `${sDSlot?.start_time} - ${sDSlot?.end_time}`
                              : "Time"}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="w-100 text-center py-3">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* Note */}
                {/* <div className="card  mb-3">
                  <div className="card-body">
                    <h5 className="fw-bold mb-3">Appointment Note.</h5>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={note || ""}
                      onChange={(e) => setNote(e.target.value)}
                    ></textarea>
                  </div>
                </div> */}
                  <div className="card mb-3">
                    <div className="card-body">
                      <OrderNotesPicker
                        apiNotes={apiNotes}
                        value={note}
                        onChange={setNote}
                      />
                    </div>
                  </div>
                {/* Next button */}
                <div className="card border-white shadow">
                  <div className="card-body">
                    {/* {deliveryDate && pickupDate ? ( */}
                    <button
                      className="btn btn-primary w-100 text-white fw-semibold"
                      disabled={loading || submitting}
                      onClick={() => {
                        if (!deliveryDate || !pickupDate) {
                          toast.error(
                            "Please select pickup & delivery dates to continue."
                          );
                          return;
                        }
                        if (!address.pickup || !address.delivery) {
                          toast.error(
                            "Please select pickup & delivery addresses to continue."
                          );
                          return;
                        }
                        if (
                          deliveryDate &&
                          pickupDate &&
                          address.pickup &&
                          address.delivery
                        )
                          placeOrder();
                      }}
                    >
                      {submitting ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                      ) : null}
                      <span className="fw-semibold">Come & Collect</span>
                    </button>
                    {/* ) : (
                      <button
                        className="btn btn-primary w-100 text-white fw-semibold"
                        onClick={() =>
                          toast.error(
                            "Please select pickup & delivery date to continue..."
                          )
                        }
                      >
                        Come & Collect
                      </button>
                    )} */}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* Pickup date modal*/}
      <Modal
        show={showPickup}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShowPickup(false)}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title style={{ fontSize: "18px" }}>
            Choose Preferred Date / Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showPickup ? (
            <DatePicker
              range={pickupRange}
              selected={sPickup}
              onChange={HandlePickupChange}
              orderType={bookingType?.id}
              timeSlot={sPSlot}
              type={1}
            />
          ) : null}
        </Modal.Body>
      </Modal>
      {/* delivery date modal*/}
      <Modal
        show={showDelivery}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShowDelivery(false)}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title style={{ fontSize: "18px" }}>
            Choose Preferred Date / Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showDelivery ? (
            <DatePicker
              range={deliveryRange}
              selected={sDelivery}
              onChange={HandleDeliveryChange}
              orderType={bookingType?.id}
              timeSlot={sDSlot}
              type={2}
              pickup={{
                date: sPickup ? format(sPickup, "yyyy-MM-dd") : null,
                slotId: sPSlot.id,
              }}
            />
          ) : null}
        </Modal.Body>
      </Modal>
      {/* Addresses modal*/}
      {Boolean(addressModal) ? (
        <AddressPicker
          show={Boolean(addressModal)}
          closeButton={true}
          onHide={() => setAddressModal(null)}
          title={` Select Your ${
            addressModal === "pickup" ? "Pickup " : "Delivery"
          } Address`}
          onSelect={HandleAddressChange}
          showEdit={false}
          showDelete={false}
        />
      ) : null}
    </>
  );
};
